import type {InferResponseType} from 'hono/client';
import type {ArticleCardLayoutsPayload} from '../../types/types.ts';
import {api} from './api-client.ts';
import type {ApiErrorResponse, ApiOKResponse} from './http.ts';
import {handleRpcResponse} from './http.ts';

type SaveArticleCardLayoutsResponse = InferResponseType<(typeof api)['article-card-layouts']['$post']>;

export async function saveArticleCardLayouts(
	payload: ArticleCardLayoutsPayload
): Promise<ApiOKResponse<SaveArticleCardLayoutsResponse> | ApiErrorResponse> {
	return handleRpcResponse<SaveArticleCardLayoutsResponse>(api['article-card-layouts'].$post({json: payload}));
}

export async function loadEditionCardLayouts(
	editionId: string
): Promise<ApiOKResponse<Record<string, ArticleCardLayoutsPayload>> | ApiErrorResponse> {
	return handleRpcResponse<Record<string, ArticleCardLayoutsPayload>>(
		api.editions[':id']['card-layouts'].$get({param: {id: editionId}})
	);
}
